/**
 * Spin wheel prize labels → YOUR REWARDS tiles (`users.{uid}.rewardsToRedeem`), same shape as coupon rewards.
 */
export const SPIN_WHEEL_REWARD_TILES = Object.freeze({
  '$50 for you': {
    title: '$50 for your dinner date',
    description: 'match and unmask to redeem',
  },
  '$50 for your friend': {
    title: '$50 for your friend',
    description:
      "enter your friend's email or IG handle to give them $50 for a dinner date.",
  },
});

/** @returns {{ title: string, description: string }} */
export function lookupSpinWheelRewardTile(prizeLabel) {
  const key = String(prizeLabel || '');
  const custom = SPIN_WHEEL_REWARD_TILES[key];
  if (custom) return { title: custom.title, description: custom.description };
  return {
    title: key || 'Spin prize',
    description: 'Fox-Paid date — match to redeem',
  };
}
